/**
 * @generated SignedSource<<de049f8b318bf10ade10b26502378d8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type UserRoleEnum = "admin" | "customer_success_rep" | "recruiter" | "sales" | "screening";
import { FragmentRefs } from "relay-runtime";
export type user_isAdmin$data = {
  readonly roles: ReadonlyArray<UserRoleEnum> | null | undefined;
  readonly " $fragmentType": "user_isAdmin";
};
export type user_isAdmin$key = {
  readonly " $data"?: user_isAdmin$data;
  readonly " $fragmentSpreads": FragmentRefs<"user_isAdmin">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "user_isAdmin"
};

(node as any).hash = "37f28d89dae2ad9e44b477f782a716a4";

export default node;
